import {
  Card,
  Table,
  Dropdown,
  Menu,
  Button,
  Space,
  message,
  Spin,
  Tag,
  Row,
  Col,
  Statistic,
  Input,
  Typography,
  Empty,
} from "antd";
import {
  DownOutlined,
  EnvironmentOutlined,
  PlusCircleOutlined,
  ReloadOutlined,
  SearchOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  CompassOutlined,
  FilterOutlined,
} from "@ant-design/icons";
import { useEffect, useMemo, useState } from "react";
import Highlighter from "react-highlight-words";
import locationService from "../../services/locationService";
import PageHeader from "../../components/headers/PageHeader";
import ModalUbicacion from "./components/ModalUbicacion";
import { METRO_COLORS } from "../../constants/colors";
import { useUser } from "../../context/UserContext";
import "./TablaUbicaciones.css";

const { Text } = Typography;

const MEDIO_CONFIG = {
  Metro: { color: METRO_COLORS.primary, rowClass: "row-metro" },
  Cable: { color: "#1890ff", rowClass: "row-cable" },
  Tranvía: { color: "#fa8c16", rowClass: "row-tranvia" },
  Bus: { color: "#722ed1", rowClass: "row-bus" },
};

export default function TablaUbicaciones() {
  const { idToken } = useUser();
  const [data, setData] = useState([]);
  const [loadingRows, setLoadingRows] = useState({});

  const [globalSearch, setGlobalSearch] = useState("");
  const [filteredInfo, setFilteredInfo] = useState({});
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");

  const toggleActive = async (record) => {
    let idLocation = record.zone + "_" + record.name;
    setLoadingRows((prev) => ({ ...prev, [record.name]: true }));

    if (record.isActive) {
      try {
        await locationService.deshabilitarLocacion(idLocation, idToken);
        message.success(`Ubicación desahabilitada`);
        consultaProtocolos();
      } catch (error) {
        message.error("No se logro hacer la solicitud");
        console.error("❌ No se logro editar la ubicacion :", error);
      } finally {
        setLoadingRows((prev) => ({ ...prev, [record.name]: false }));
      }
    } else {
      try {
        await locationService.habilitarLocacion(idLocation, idToken);
        message.success(`Ubicación habilitada`);
        consultaProtocolos();
      } catch (error) {
        message.error("No se logro hacer la solicitud");
        console.error("❌ No se logro editar la ubicacion :", error);
      } finally {
        setLoadingRows((prev) => ({ ...prev, [record.name]: false }));
      }
    }
  };

  const handleCreate = async (record) => {
    // Aquí puedes abrir un modal si deseas
    let payload = { ...record };

    // Asignar vehicle
    payload.vehicle = record.means;

    // Limpiar y formatear specific y name
    if (payload.specific) {
      payload.specific = payload.specific.replace(/\s+/g, "").toUpperCase();
    }
    if (payload.name) {
      payload.name = payload.name.replace(/\s+/g, "").toUpperCase();
    }

    try {
      await locationService.crearLocacion(payload, idToken);
      message.success(`Ubicación creada`);
      consultaProtocolos();
    } catch (error) {
      message.error("No se logro hacer la solicitud");
      console.error("❌ No se logro crear la ubicacion :", error);
    }
  };

  const ActionsMenu = ({ record, setLoadingRows, refresh }) => {
    const [editarLocacion, setEditarLocacion] = useState(false);

    const handleEditar = async (data) => {
      // Aquí puedes abrir un modal si deseas
      let payload = { ...record };
      setLoadingRows((prev) => ({ ...prev, [data.name]: true }));

      // Asignar vehicle
      payload.vehicle = data.means;
      payload.name = data.name;
      payload.specific = data.specific;
      payload.geolocation = data.geolocation;
      payload.type = data.type;
      payload.geolocation = data.geolocation;
      payload.zone = data.zone;
      payload.means = data.means;
      // Limpiar y formatear specific y name
      if (payload.specific) {
        payload.specific = payload.specific.replace(/\s+/g, "").toUpperCase();
      }
      if (payload.name) {
        payload.name = payload.name.replace(/\s+/g, "").toUpperCase();
      }

      let idLocation = payload.zone + "_" + payload.name;

      try {
        await locationService.editarLocacion(payload, idLocation, idToken);
        message.success(`Ubicación editada`);
        refresh();
      } catch (error) {
        message.error("No se logro hacer la solicitud");
        console.error("❌ No se logro editar la ubicacion :", error);
      } finally {
        setLoadingRows((prev) => ({ ...prev, [data.name]: false }));
      }
    };

    return (
      <>
        <Menu>
          <Menu.Item key="edit" onClick={() => setEditarLocacion(true)}>
            Editar
          </Menu.Item>
          <Menu.Item key="toggle" onClick={() => toggleActive(record)}>
            {record.isActive ? "Desactivar" : "Activar"}
          </Menu.Item>
        </Menu>
        <ModalUbicacion
          setOpen={setEditarLocacion}
          open={editarLocacion}
          type="editar"
          ubicacion={record}
          onSubmit={handleEditar}
        ></ModalUbicacion>
      </>
    );
  };

  // --- Búsqueda por columna: entrada de texto en cada filtro ---
  const handleColumnSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0] || "");
    setSearchedColumn(dataIndex);
  };

  const handleColumnReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex, label, renderExtra) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          autoFocus
          placeholder={`Buscar ${label}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleColumnSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 200, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleColumnSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
              background: METRO_COLORS.primary,
              borderColor: METRO_COLORS.primary,
            }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => clearFilters && handleColumnReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Limpiar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{ color: filtered ? METRO_COLORS.primary : undefined }}
      />
    ),
    filteredValue: filteredInfo[dataIndex] || null,
    onFilter: (value, record) => {
      const field = record[dataIndex];
      return field
        ? field.toString().toLowerCase().includes(value.toLowerCase())
        : false;
    },
    render: (text, record) => {
      const node =
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: "#d9f7be", padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text ? text.toString() : ""}
          />
        ) : (
          text
        );
      return renderExtra ? renderExtra(node, record) : node;
    },
  });

  const columns = [
    {
      title: "Código",
      dataIndex: "specific",
      key: "specific",
      width: 110,
      ...getColumnSearchProps("specific", "código", (node) => (
        <Tag style={{ fontFamily: "monospace", margin: 0 }}>{node}</Tag>
      )),
    },
    {
      title: "Nombre",
      dataIndex: "name",
      key: "name",
      ...getColumnSearchProps("name", "nombre", (node) => (
        <Space>
          <EnvironmentOutlined style={{ color: METRO_COLORS.primary }} />
          <span className="font-medium">{node}</span>
        </Space>
      )),
    },
    {
      title: "Medio",
      dataIndex: "means",
      key: "means",
      responsive: ["sm"],
      ...getColumnSearchProps("means", "medio", (node, record) => {
        if (!record.means) return <Text type="secondary">—</Text>;
        const cfg = MEDIO_CONFIG[record.means];
        return (
          <Tag color={cfg?.color} style={{ margin: 0 }}>
            {node}
          </Tag>
        );
      }),
    },
    {
      title: "Zona",
      dataIndex: "zone",
      key: "zone",
      width: 90,
      ...getColumnSearchProps("zone", "zona"),
    },
    {
      title: "Tipo",
      dataIndex: "type",
      key: "type",
      responsive: ["md"],
      ...getColumnSearchProps("type", "tipo", (node) => (
        <Tag style={{ margin: 0 }}>{node}</Tag>
      )),
    },
    {
      title: "Estado",
      dataIndex: "isActive",
      key: "isActive",
      width: 110,
      filters: [
        { text: "Activo", value: true },
        { text: "Inactivo", value: false },
      ],
      filteredValue: filteredInfo.isActive || null,
      onFilter: (value, record) => record.isActive === value,
      render: (isActive) => (
        <Tag color={isActive ? "green" : "red"}>
          {isActive ? "Activo" : "Inactivo"}
        </Tag>
      ),
    },
    {
      title: "Acciones",
      key: "acciones",
      width: 90,
      render: (_, record) => (
        <Space>
          {loadingRows[record.name] ? (
            <Spin></Spin>
          ) : (
            <Dropdown
              overlay={
                <ActionsMenu
                  record={record}
                  refresh={consultaProtocolos}
                  setLoadingRows={setLoadingRows}
                />
              }
              trigger={["click"]}
            >
              <Button
                type="text"
                onClick={(e) => e.preventDefault()}
                icon={<DownOutlined />}
              />
            </Dropdown>
          )}
        </Space>
      ),
    },
  ];

  const [loadingButton, setLoadingButton] = useState(true);
  const [crearLocacion, setCrearLocacion] = useState(false);

  const consultaProtocolos = async () => {
    if (!idToken) return;
    setLoadingButton(true);
    try {
      let ubicaciones = [];
      let lastEvaluatedKey = null;

      do {
        const response = await locationService.consultarUbicaciones(
          idToken,
          lastEvaluatedKey
        );
        ubicaciones = [...ubicaciones, ...(response?.Items || [])];
        lastEvaluatedKey = response?.LastEvaluatedKey || null;
      } while (lastEvaluatedKey);

      setData(ubicaciones);
    } catch (error) {
      console.error("Error fetching data:", error);
      message.error("No se logro hacer la consulta");
    }
    setLoadingButton(false);
  };

  useEffect(() => {
    // Este código se ejecutará solo cuando `open` sea `true`

    consultaProtocolos();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idToken]);

  const stats = useMemo(() => {
    const total = data.length;
    const activas = data.filter((d) => d.isActive).length;
    const zonas = new Set(data.map((d) => d.zone)).size;
    return { total, activas, inactivas: total - activas, zonas };
  }, [data]);

  const filteredData = useMemo(() => {
    const q = globalSearch.trim().toLowerCase();
    if (!q) return data;
    return data.filter((item) =>
      [item.name, item.specific, item.zone, item.type, item.means]
        .filter((v) => v !== undefined && v !== null)
        .some((v) => v.toString().toLowerCase().includes(q))
    );
  }, [data, globalSearch]);

  const hasActiveFilters =
    globalSearch.trim() !== "" ||
    Object.values(filteredInfo).some((v) => v && v.length);

  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });

  useEffect(() => {
    setPagination((p) => ({ ...p, current: 1 }));
  }, [globalSearch]);

  const clearAllFilters = () => {
    setFilteredInfo({});
    setGlobalSearch("");
    setSearchText("");
    setSearchedColumn("");
    setPagination((p) => ({ ...p, current: 1 }));
  };

  const rowClassName = (record) => {
    const cfg = MEDIO_CONFIG[record.means];
    const classes = [cfg?.rowClass].filter(Boolean);
    if (!record.isActive) classes.push("row-inactive");
    return classes.join(" ");
  };

  return (
    <Card
      title={
        <PageHeader
          title="Ubicaciones Registradas"
          head={`${stats.total} ubicaciones en el sistema`}
        ></PageHeader>
      }
      bordered={true}
      extra={
        <>
          <Button
            style={{ marginRight: "5px" }}
            icon={<ReloadOutlined></ReloadOutlined>}
            onClick={() => consultaProtocolos()}
          ></Button>

          <Button
            icon={<PlusCircleOutlined></PlusCircleOutlined>}
            type="primary"
            onClick={() => setCrearLocacion(true)}
          >
            Crear Ubicación
          </Button>

          <ModalUbicacion
            setOpen={setCrearLocacion}
            open={crearLocacion}
            type="crear"
            onSubmit={handleCreate}
          ></ModalUbicacion>
        </>
      }
    >
      <Row gutter={16} style={{ marginBottom: 20 }}>
        {[
          {
            title: "Total",
            value: stats.total,
            icon: <EnvironmentOutlined />,
            color: METRO_COLORS.primary,
          },
          {
            title: "Activas",
            value: stats.activas,
            icon: <CheckCircleOutlined />,
            color: "#52c41a",
          },
          {
            title: "Inactivas",
            value: stats.inactivas,
            icon: <CloseCircleOutlined />,
            color: "#ff4d4f",
          },
          {
            title: "Zonas",
            value: stats.zonas,
            icon: <CompassOutlined />,
            color: "#1890ff",
          },
        ].map((s) => (
          <Col xs={12} sm={6} key={s.title}>
            <Card size="small" bordered className="locations-stat-card">
              <Statistic
                title={s.title}
                value={s.value}
                prefix={s.icon}
                valueStyle={{ color: s.color, fontSize: 24 }}
              />
            </Card>
          </Col>
        ))}
      </Row>

      <Row gutter={12} align="middle" style={{ marginBottom: 16 }}>
        <Col xs={24} sm={14} md={10}>
          <Input
            allowClear
            placeholder="Buscar por nombre, código, zona, tipo o medio..."
            prefix={<SearchOutlined style={{ color: "#bfbfbf" }} />}
            value={globalSearch}
            onChange={(e) => setGlobalSearch(e.target.value)}
          />
        </Col>
        <Col>
          <Text type="secondary">
            Mostrando {filteredData.length} de {stats.total} ubicaciones
          </Text>
        </Col>
        {hasActiveFilters && (
          <Col>
            <Button
              type="link"
              icon={<FilterOutlined />}
              onClick={clearAllFilters}
            >
              Limpiar filtros
            </Button>
          </Col>
        )}
      </Row>

      <Table
        className="locations-table"
        dataSource={filteredData}
        columns={columns}
        loading={loadingButton}
        rowKey="name"
        rowClassName={rowClassName}
        onChange={(pag, filters) => {
          setFilteredInfo(filters);
          setPagination({ current: pag.current, pageSize: pag.pageSize });
        }}
        scroll={{ x: "max-content" }}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          showSizeChanger: true,
          showQuickJumper: true,
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} de ${total} ubicaciones`,
          pageSizeOptions: ["10", "20", "50", "100"],
        }}
        locale={{
          filterConfirm: "Aceptar",
          filterReset: "Limpiar",
          emptyText:
            stats.total === 0 ? (
              <Empty
                description="No hay ubicaciones registradas. Crea la primera desde el botón «Crear Ubicación»."
                image={Empty.PRESENTED_IMAGE_SIMPLE}
              />
            ) : (
              <Empty
                description="No se encontraron ubicaciones con los filtros aplicados."
                image={Empty.PRESENTED_IMAGE_SIMPLE}
              />
            ),
        }}
      />
    </Card>
  );
}
